(function () {
  function getLanguage() {
    const lang = document.documentElement.lang || '';
    if (lang.toLowerCase().startsWith('it')) return 'it';

    const path = window.location.pathname;
    if (path.startsWith('/it')) return 'it';

    return 'en';
  }

  const translations = {
    en: {
      add: 'Add to Wishlist',
      remove: 'Remove from Wishlist',
    },
    it: {
      add: 'Aggiungi ai preferiti',
      remove: 'Rimuovi dalla lista dei desideri',
    },
  };

  function updateButtonText(button) {
    const lang = getLanguage();
    const t = translations[lang];

    const textEl = button.querySelector('.xb-wishlist-button__text');
    if (!textEl) return;

    const isRemove  = button.classList.contains('xb-wishlist-button__remove-style');
    const isAdd     = button.classList.contains('xb-wishlist-button__add-style');
    const isLoading = button.classList.contains('xb-wishlist-button__loading-style');

    if (isLoading) return;

    if (isRemove) textEl.textContent = t.remove;
    else if (isAdd) textEl.textContent = t.add;
  }

  function updateAllButtons() {
    document
      .querySelectorAll(
        '.xb-wishlist-button__remove-style, .xb-wishlist-button__add-style'
      )
      .forEach(updateButtonText);
  }

  // ── On Load: Poll until custom element is ready ──────────────────────────
  // The xb-wishlist custom element renders AFTER the page loads,
  // so we poll until the button appears and then translate it.
  function waitForButtonsOnLoad() {
    const maxWait  = 5000;  // wait up to 5s for custom element to render
    const interval = 100;
    let   elapsed  = 0;

    const poll = setInterval(function () {
      elapsed += interval;

      const buttons = document.querySelectorAll(
        '.xb-wishlist-button__remove-style, .xb-wishlist-button__add-style'
      );

      if (buttons.length > 0) {
        // Check none are still in loading state
        const anyLoading = document.querySelector('.xb-wishlist-button__loading-style');
        if (anyLoading) return; // wait for loading to finish

        clearInterval(poll);
        buttons.forEach(updateButtonText);
        return;
      }

      // Also check if xb-wishlist-button exists but class not yet set
      // (custom element connected but not yet resolved its state)
      const xbButtons = document.querySelectorAll('xb-wishlist-button');
      if (xbButtons.length > 0 && elapsed >= 500) {
        // Element is in DOM but no add/remove class yet — keep waiting
      }

      if (elapsed >= maxWait) {
        clearInterval(poll);
        updateAllButtons(); // final attempt
      }
    }, interval);
  }

  // ── Click handler ────────────────────────────────────────────────────────
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(
        '.xb-wishlist-button__remove-style, .xb-wishlist-button__add-style'
      );
      if (!btn) return;

      const wasRemove = btn.classList.contains('xb-wishlist-button__remove-style');

      const maxWait  = 2000;
      const interval = 100;
      let   elapsed  = 0; 

      const poll = setInterval(function () {
        elapsed += interval;

        const isLoading = btn.classList.contains('xb-wishlist-button__loading-style');
        if (isLoading) return;

        const isNowRemove = btn.classList.contains('xb-wishlist-button__remove-style');
        const isNowAdd    = btn.classList.contains('xb-wishlist-button__add-style');
        const toggled     = wasRemove ? isNowAdd : isNowRemove;

        if (toggled || elapsed >= maxWait) {
          clearInterval(poll);
          updateAllButtons();
        }
      }, interval);
    },
    false
  );

  // ── MutationObserver ─────────────────────────────────────────────────────
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {

      // ── Class change: loading removed → translate ──────────────────────
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;

        const wasLoading = mutation.oldValue?.includes('xb-wishlist-button__loading-style');
        const isLoading  = target.classList.contains('xb-wishlist-button__loading-style');

        if (wasLoading && !isLoading) {
          updateButtonText(target);
          return;
        }

        // ── On load: class set for first time (no loading phase) ──────────
        // Covers case where custom element sets add/remove class directly
        // without going through loading state on initial render
        const hasAdd    = target.classList.contains('xb-wishlist-button__add-style');
        const hasRemove = target.classList.contains('xb-wishlist-button__remove-style');
        const hadAdd    = mutation.oldValue?.includes('xb-wishlist-button__add-style');
        const hadRemove = mutation.oldValue?.includes('xb-wishlist-button__remove-style');

        // Class just appeared for the first time on load
        if ((hasRemove && !hadRemove) || (hasAdd && !hadAdd)) {
          updateButtonText(target);
        }
      }

      // ── New nodes: fresh render ────────────────────────────────────────
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches?.(
            '.xb-wishlist-button__remove-style, .xb-wishlist-button__add-style'
          )
        ) {
          updateButtonText(node);
        } else {
          node
            .querySelectorAll?.(
              '.xb-wishlist-button__remove-style, .xb-wishlist-button__add-style'
            )
            .forEach(updateButtonText);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList:        true,
    subtree:          true,
    attributes:       true,
    attributeFilter:  ['class'],
    attributeOldValue: true,
  });

  // ── Start load-time polling ──────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForButtonsOnLoad);
  } else {
    waitForButtonsOnLoad(); // DOM already ready
  }

})();